import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useFornecedoresListaFilters
 */

type State = {
  razaoSocial: string;
  cnpj: string;
  cpf: string;
  nomeFantasia: string;
  centroCustos: number[] | null;
  familias: string[] | null;
  atividades: string[] | null;
  documento: number;
  tipoFornecedor: number;
  status: number;
  avaliacaoCentroCusto: number[] | null;
};

export const initialFornecedoresListaFilters: State = {
  razaoSocial: '',
  cnpj: '',
  cpf: '',
  nomeFantasia: '',
  centroCustos: null,
  familias: null,
  atividades: null,
  documento: 1,
  tipoFornecedor: 1,
  status: 1,
  avaliacaoCentroCusto: null,
}

export const useFornecedoresListaFilters = create<State>((set) => ({
  ...initialFornecedoresListaFilters,
}));